/* eslint-disable @typescript-eslint/no-floating-promises */
import { useMsal } from '@azure/msal-react';
import { AxiosError } from 'axios';
import { FC, ReactNode } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { SWRConfig } from 'swr';

interface SWRConfigWrapperProps {
  children: ReactNode;
}

const SWRConfigWrapper: FC<SWRConfigWrapperProps> = ({ children }) => {
  const { showBoundary } = useErrorBoundary();
  const { instance, accounts } = useMsal();

  return (
    <SWRConfig
      value={{
        onError: (error: AxiosError, key) => {
          if (!error.response) {
            // ignore errors that are not from the API Gateway
            return;
          }
          if (error.response?.status === 401) {
            // When an API call fails with 401, it usually means the access token is expired or invalid.
            // We can try to acquire a new token silently first.
            // If silent acquisition fails, it will fall back to a redirect.
            const request = {
              scopes: [`api://${process.env.REACT_APP_CLIENT_ID ?? ''}/Admins`],
              account: accounts[0],
            };
            // eslint-disable-next-line no-shadow
            instance.acquireTokenSilent(request).catch((msalError) => {
              console.error('Silent token acquisition failed,redirecting for login:', msalError);
              // instance.loginRedirect(request);
            });
          } else if (typeof key === 'string' && key.indexOf('ignoreError:true') === -1) {
            // NOTE: key can be object, so check if it is string
            showBoundary(error);
          }
        },
      }}
    >
      {children}
    </SWRConfig>
  );
};
export default SWRConfigWrapper;
